// src/components/players/VideoPlayer.js (نسخه نهایی با History Tracking)

import React, { useEffect, useRef, useState } from 'react'; // 🟢 useState اضافه شد
import { X } from 'lucide-react';
// 🟢 ۱. ایمپورت هوک تاریخچه
import useHistoryTracking from '../../hooks/useHistoryTracking'; 

/**
 * یک مدال (Modal) برای نمایش پلیر ویدیو
 * @param {object} props
 * @param {object} props.mediaItem - شامل id, url و title
 * @param {number} props.initialTime - موقعیت پخش اولیه ذخیره شده
 * @param {function} props.onClose - تابع بستن
 */
const VideoPlayer = ({ mediaItem, onClose, initialTime }) => {
    const videoRef = useRef(null);
    // 🟢 ۲. وضعیت پخش داخلی (برای ارسال به هوک Heartbeat)
    const [isPlaying, setIsPlaying] = useState(true); 

    // 🟢 ۳. فعال‌سازی هوک تاریخچه
    const mediaId = mediaItem?.id;
    // 💡 دریافت موقعیت پخش از رفرنس ویدیو (به‌روزرسانی در زمان‌های مشخص)
    const currentTime = videoRef.current?.currentTime || 0; 
    
    // 🛑 فراخوانی هوک برای فعال‌سازی تایمر Heartbeat
    useHistoryTracking(
        mediaId, 
        currentTime, 
        isPlaying 
    );
    
    // 🛑 دستور کنسول لاگ برای بررسی وضعیت URL ورودی
    useEffect(() => {
        if (mediaItem && mediaItem.url) {
            console.log("✅ VideoPlayer Loaded with URL (Presigned?):", mediaItem.url);
            console.log("⚠️ CAUTION: URL length:", mediaItem.url.length); 
        } else {
            console.log("❌ VideoPlayer URL is MISSING or null.");
        }
    }, [mediaItem]);
    
    // 🟢 ۴. useEffect برای تنظیم زمان شروع و رویدادهای پخش
    useEffect(() => {
        const video = videoRef.current;
        if (!video || !mediaItem) return;

        // 💡 تنظیم زمان شروع پخش
        if (initialTime > 0) {
            video.currentTime = initialTime;
            console.log(`[VIDEO HISTORY] Resuming playback from ${initialTime}s.`);
        }
        
        // 💡 شنونده‌ها برای آپدیت وضعیت isPlaying
        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);
        const handleEnded = () => onClose(); 
        
        video.addEventListener('play', handlePlay);
        video.addEventListener('pause', handlePause);
        video.addEventListener('ended', handleEnded);

        return () => {
            video.removeEventListener('play', handlePlay);
            video.removeEventListener('pause', handlePause);
            video.removeEventListener('ended', handleEnded);
        };
    }, [mediaItem, onClose, initialTime]);


    // ... (کدهای useEffect برای Escape و handleContentClick بدون تغییر)
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);

    // جلوگیری از کلیک روی خود ویدیو و بسته شدن مدال
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    // 🛑 مدیریت خطای پخش ویدیو (برای عیب‌یابی خطای 401/403)
    const handleVideoError = (e) => {
        const error = e.target.error;
        if (error) {
            console.error("🚨 Video Playback Error Code:", error.code);
            console.error("🚨 Video Playback Error Message (Network/Security Issue):", error.message);
            if (error.code === 4) {
                 console.error("🚨 احتمالاً لینک منقضی شده یا دسترسی رد شده است (401/403).");
            }
        }
    };

    if (!mediaItem) return null;

    return (
        <div 
            className="fixed inset-0 z-[30] bg-black/80 flex items-center justify-center p-4 rtl"
            onClick={onClose} 
        >
            {/* کانتینر اصلی ویدیو */}
            <div 
                className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden shadow-2xl"
                onClick={handleContentClick}
            >
                {/* دکمه بستن در گوشه */}
                <button 
                    onClick={onClose}
                    className="absolute top-2 right-2 z-20 p-1.5 bg-gray-800/50 text-white rounded-full hover:bg-red-600 transition-colors"
                    title="بستن (Esc)"
                >
                    <X size={24} />
                </button>

                {/* هدر (عنوان ویدیو) */}
                <div className="absolute top-0 left-0 right-0 z-10 p-4 bg-gradient-to-b from-black/60 to-transparent">
                    <h3 className="text-[12px] font-bold text-white truncate">
                        {mediaItem.title || 'پخش ویدیو'}
                    </h3>
                </div>

                {/* عنصر <video> */}
                <video
                    ref={videoRef}
                    src={mediaItem.url} 
                    controls 
                    autoPlay 
                    className="w-full h-auto max-h-[85vh] aspect-video"
                    onError={handleVideoError}
                >
                    {/* Fallback برای مرورگرهای قدیمی */}
                    مرورگر شما از تگ ویدیو پشتیبانی نمی‌کند.
                </video>
            </div>
        </div>
    );
};

export default VideoPlayer;